<template>
  <v-row>
    <v-col cols="12" class="pt-5 pt-md-9 pb-2">
      <router-link :to="{ name: 'hosting_cpanel_info', params: { id: $route.params.id }, query: { user: $route.query.user } }"
                   class="d-flex align-center text-decoration-none">
        <v-icon size="20">mdi-keyboard-backspace</v-icon>
        Go back to managing {{ hosting.domain }}
      </router-link>
    </v-col>
    <v-col cols="12">
      <div>
        <div v-if="missinghistory || hasInvoice">
          <p v-show="hasInvoice">
            This service has an open invoice. Please contact Sales for assistance with your request.
          </p>
          <p v-show="missinghistory">
            Your account needs to be reviewed by our team before your plan can be changed.
            You can speak to one of our 24/7 live chat agents to assist you.
          </p>
          <gg-btn @click="prefillAndOpenChat">
            Speak to 24/7 Live Agent
          </gg-btn>
        </div>
        <v-item-group v-else v-model="selected" mandatory>
          <v-row>
            <v-col v-for="(item, i) in items" :key="i" cols="12" md="3">
              <v-item v-slot="{ active, toggle }" :value="item.key">
                <v-card class="app-card" @click="toggle">
                  <v-card-text
                    class="text-center pa-0"
                    :style="active ? 'border: 2px solid #0ca750 !important' : 'border: 2px solid rgba(0, 0, 0, 0.12) !important'">
                    <v-chip color="primary" x-small class="current-plan" v-if="item.current">Current Plan</v-chip>
                    <v-tooltip
                      v-if="item.promotion"
                      bottom
                      color="primary"
                      max-width="300"
                      content-class="opacity-100">
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          color="primary"
                          v-on="on"
                          x-small
                          class="current-plan"
                        >
                          <v-icon size="14" color="#ffd859">mdi-star</v-icon>
                          <span style="padding: 1px 0 0 3px;">On Sale</span>
                        </v-chip>
                      </template>
                      <div class="d-flex flex-column justify-space-between">
                        <div class="font-weight-bold text-center">{{ item.promotion_name }}</div>
                        <div class="text-center">{{ item.promotion_description }}</div>
                      </div>
                    </v-tooltip>

                    <h2 class="pt-10 pb-10">
                      {{ item.name }}
                      <v-icon size="medium">
                        {{ iconFlag(item.flag) }}
                      </v-icon>
                    </h2>

                    <div v-if="!item.isCurrent && !item.promotion">
                      <h3 class="pb-1 mb-0">
                        {{ moneyFormat(item.price_monthly) }}/month
                      </h3>
                      <span class="mb-3 d-block">
                        Renewal price {{ moneyFormat(item.price_renewal_monthly) }}/month
                      </span>
                    </div>
                    <h3 v-else-if="!item.promotion" class="pb-4">
                      {{ moneyFormat(filterPrice(item.selectedTerm, item)) }}/month
                    </h3>
                    <h3 v-else class="pb-4">
                      {{ pricePromotion(item) }}{{ item.promotion_type == 'monthly' ? '/month' : ' today' }}
                    </h3>

                    <gg-btn :color="!active ? 'primary' : $vuetify.theme.dark ? 'light' : 'white' "
                            large
                            tile
                            class="mb-4"
                            :href="item.url"
                            target="_blank"
                            @click="toggle">
                      <v-icon v-show="active" small>mdi-check-bold</v-icon>
                      Select{{ active ? 'ed' : '' }} Plan
                    </gg-btn>

                    <template v-if="item.features">
                      <div v-show="item.features.inherits.length > 0"
                           class="mb-3 text-left mx-4 body-2">
                        Includes everything in {{ [...item.features.inherits, ''].toString().replace(',', ', ') }} plus:
                      </div>
                      <div v-show="item.features.features.length > 0" class="mb-6">
                        <ul class="text-left list-unstyled mx-4">
                          <li v-for="(feature, fi) in item.features.features"
                              :key="`feature${fi}`" class="subtitle-1">
                            {{ feature }}
                          </li>
                        </ul>
                      </div>
                    </template>
                  </v-card-text>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        </v-item-group>

      </div>
    </v-col>

    <v-col cols="12" v-if="selectedPlan && !hasInvoice && !missinghistory">
      <plan-details-card
        :selected-plan="selectedPlan"
        :current-plan="currentPlan"
        :time-left="timeLeft"
        :renewal-date="renewalDate"
        :money-format="moneyFormat"
      />
    </v-col>

    <v-col cols="12" lg="4" md="6" v-if="selectedPlan && !hasInvoice && !missinghistory">
      <template v-if="!selectedPlan.current">
        <gg-card class="mb-4">
          <gg-card-header>
            Payment Summary
          </gg-card-header>
          <gg-card-text>
            <v-row>
              <v-col cols="6" class="h4 font-weight-regular">Upgrade Price</v-col>
              <v-col cols="6" md="4" class="justify-end">
                <div class="text-right h4 font-weight-regular">{{ moneyFormat(selectedPlan.price) }}</div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="h4 font-weight-bold">
                {{ selectedPlan.credit > 0 ? 'Credit Owed' : 'Total Due' }}
              </v-col>
              <v-col cols="6" md="4" class="justify-end">
                <div class="text-right h4 font-weight-bold">
                  {{ moneyFormat(selectedPlan.credit || selectedPlan.price) }}
                </div>
              </v-col>
            </v-row>
          </gg-card-text>
        </gg-card>
        <gg-card v-if="!selectedPlan.credit">
          <gg-card-header>
            Payment Method
          </gg-card-header>
          <gg-card-text>
            <v-row>
              <v-col cols="12">
                <payment-gateway
                  class="mt-4"
                  no-padding
                  card-select
                  :card-type="SessionProfile.card_type"
                  :toolbar="false"
                  :paypal="false"
                  :compact="true"
                  card-selection-label="Select Card"
                  ref="paymentGateway"
                  @card="listenCard"
                  @card-switch="listenCardNew"
                />
              </v-col>
            </v-row>
          </gg-card-text>
        </gg-card>
        <v-row class="mt-0">
          <v-col v-if="term" cols="12">
            <v-checkbox v-model="agreeCheckbox" class="mt-2">
              <template #label>
                <div>
                  I confirm that I wish to change my hosting plan to the selection made above and have read
                  and understood the
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <a
                        target="_blank"
                        href="https://www.greengeeks.com/legal/tos"
                        @click.stop
                        v-on="on"
                      >
                        Terms of Service
                      </a>
                    </template>
                    Open in new tab
                  </v-tooltip>
                  and have acknowledged the receipt of the
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <a
                        target="_blank"
                        href="https://www.greengeeks.com/legal/privacy"
                        @click.stop
                        v-on="on"
                      >
                        Privacy Policy
                      </a>
                    </template>
                    Open in new tab
                  </v-tooltip>.
                  All changes are effective immediately unless otherwise specified.
                </div>
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="12">
            <gg-btn :disabled="!agreeCheckbox" :loading="requestLoading" @click="sendRequest">
              Change Plan
            </gg-btn>
          </v-col>
        </v-row>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { isEmpty, moneyFormat, openChat } from '@/helpers/helpers'
import PaymentGateway from '@/components/Common/PaymentGateway'
import PlanDetailsCard from '@/components/Services/Hosting/Shared/Updowngrade/PlanDetailsCard'

export default {
  name: 'CreateRequest',
  components: {
    PaymentGateway,
    PlanDetailsCard
  },
  props: {
    hostingid: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      items: [],
      credit: null,
      loading: true,
      requestLoading: false,
      selected: 0,
      term: '',
      agreeCheckbox: false,
      isNewCard: false,
      hasInvoice: false,
      missinghistory: false,
      timeLeft: '',
      daysLeft: '',
      renewalDate: '',
      card: {
        cardnum: '',
        cardnum_cvv: '',
        expdate: ''
      }
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  async mounted () {
    await this.getData()
  },
  computed: {
    ...mapGetters(['hosting', 'SessionProfile']),
    selectedPlan () {
      if (this.items.length === 0) {
        return {}
      }

      return this.items[this.selected]
    },
    currentPlan () {
      if (this.items.length === 0) {
        return {}
      }

      return this.items.find(item => item.current)
    },
    chatLink () {
      const params = encodeURIComponent(`name=${this.SessionProfile.firstname} ${this.SessionProfile.lastname}`) +
        encodeURIComponent(`&customerid=${this.SessionProfile.accountId}`)
      return `https://direct.lc.chat/7133161/4?params=${params}`
    }
  },
  methods: {
    ...mapActions({
      getUpgradesData: 'updowngrade/getUpgradesData',
      submitRequest: 'updowngrade/submitRequest',
      getProfile: 'getProfile',
      reportError: 'reportError'
    }),
    ...mapMutations({
      'setUpdowngrade': 'SET_HOSTING_UPDOWNGRADE_REQUEST',
    }),
    isEmpty,
    moneyFormat,
    openChat,
    // livechat docs: https://platform.text.com/docs/extending-chat-widget/javascript-api/v1.0#using-chat-window-api
    prefillAndOpenChat () {
      const lcApi = window.LC_API || {}
      lcApi.set_visitor_name(`${this.SessionProfile.firstname} ${this.SessionProfile.lastname}`)
      lcApi.set_visitor_email(this.SessionProfile.email)
      lcApi.set_custom_variables([
        { name: 'Customer ID', value: this.SessionProfile.accountId },
        { name: 'Subject', value: `Plan change assistance for ${this.hosting.domain}` },
        { name: 'Domain', value: this.hosting.domain },
        { name: 'Service ID', value: this.hostingid },
      ])

      openChat()
    },
    pricePromotion (promotion) {
      return promotion.promotion_type == 'monthly' ? moneyFormat(promotion.price_monthly) : moneyFormat(promotion.price)
    },
    listenCard (card) {
      this.card = card
    },
    listenCardNew (isNew) {
      this.isNewCard = isNew
    },
    async getData () {
      try {
        this.loading = true
        const {
          currentplan,
          credit,
          options,
          hasinvoice,
          missinghistory,
          timeleft,
          renewaldate,
          daysleft
        } = await this.getUpgradesData(this.hostingid)

        if (hasinvoice) {
          this.hasInvoice = hasinvoice
          return
        }

        if (missinghistory) {
          this.missinghistory = missinghistory
          return
        }

        this.timeLeft = timeleft || ''
        this.daysLeft = daysleft || ''
        this.renewalDate = renewaldate || ''
        // add the current plan to a list
        this.items.push({
          ...currentplan,
          selectedTerm: currentplan.term,
          isCurrent: true,
          showAllFeatures: false
        })
        // add the rest of plans to the list
        options.forEach(item => {
          this.items.push({
            ...item,
            selectedTerm: currentplan.term,
            showAllFeatures: false
          })
        })

        this.term = currentplan.term.toLowerCase()

        this.selectPathPlan()

        this.credit = credit
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    },
    selectPathPlan () {
      // if path (plan id) was specified in the route - select it
      const path = this.$route.params.path
      const planIndex = this.items.findIndex(plan => plan.id == path)
      if (this.items[planIndex]) {
        this.selected = planIndex
      }
    },
    toUpperCase (string) {
      return string.replace(/^./, string[0].toUpperCase())
    },
    filterPrice (term, plan) {
      if (plan.current) {
        return plan.price_monthly
      } else {
        return plan.pricing[term].standard
      }
    },
    iconFlag (country) {
      let iconClass = ''
      switch (country) {
        case 'US':
          iconClass = 'flag-icon flag-icon-us mr-4'
          break
        case 'CA':
          iconClass = 'flag-icon flag-icon-ca mr-4'
          break
        case 'EU':
          iconClass = 'flag-icon flag-icon-nl mr-4'
          break
      }
      return iconClass
    },
    async sendRequest () {
      if (!this.selectedPlan.credit) {
        const validCard = await this.$refs.paymentGateway.validateForm()
        if (!validCard) {
          return
        }
      }

      try {
        this.requestLoading = true

        const data = {
          id: this.hostingid,
          path_id: this.selectedPlan.id,
          term: this.term.toLowerCase(),
          cardnum: this.isNewCard ? this.card.cardnum : undefined,
          cardnum_cvv: this.card.cardnum_cvv,
          expdate: this.isNewCard ? this.card.expdate : undefined,
        }

        const { request_id } = await this.submitRequest(data)
        // fetch fresh profile data if new card was added
        if (this.isNewCard) {
          await this.getProfile()
        }

        this.setUpdowngrade(request_id)

        await this.$router.push({
          name: 'hosting_view_request',
          params: { id: request_id }
        })
      } catch (e) {
        this.reportError(e)
      } finally {
        this.requestLoading = false
      }
    }
  },
  watch: {
    selected (val) {
      this.term = this.items[val].selectedTerm
    },
    term (val) {
      this.items[this.selected].selectedTerm = val
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  list-style: none;
}

.align-right {
  text-align: right;
}

.current-plan {
  position: absolute;
  top: 10px;
  right: 10px;
}

.flag-icon {
  background-size: contain;
  background-position: 50%;
  background-repeat: no-repeat;
  position: relative;
  display: inline-block;
  width: 1.33333333em;
  line-height: 1em;
}

.flag-icon:before {
  content: "\00a0";
}

.flag-icon-us {
  background-image: url('/static/flag-icons/us.svg');
}

.flag-icon-ca {
  background-image: url('/static/flag-icons/ca.svg');
}

.flag-icon-nl {
  background-image: url('/static/flag-icons/eu.svg');
}

.opacity-100 {
  opacity: 1 !important;
}
</style>
